import { render, staticRenderFns } from "./shipment-receipts-display.vue?vue&type=template&id=8ba99892&scoped=true"
import script from "./shipment-receipts-display.vue?vue&type=script&lang=js"
export * from "./shipment-receipts-display.vue?vue&type=script&lang=js"
import style0 from "./shipment-receipts-display.vue?vue&type=style&index=0&id=8ba99892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba99892",
  null
  
)

export default component.exports